/* NUT HUT — custom sandbox JS (loaded on every page via a single <script src>) */
(function () {
  // 1) Shrinking header on scroll
  var header = document.querySelector('header.top');
  if (header) {
    var THRESHOLD = 50;
    var onScroll = function () {
      header.classList.toggle('shrink', window.scrollY > THRESHOLD);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // 2) Close the desktop search pill when clicking away from it
  document.addEventListener('click', function (e) {
    var search = document.querySelector('header.top .right a.toggle-search');
    if (search && search.classList.contains('active') && !search.contains(e.target)) {
      search.classList.remove('active');
    }
  });
})();
